export const MEMBERS_WITH_ACCESS_COLOR = "#008559";
export const MEMBERS_WITHOUT_ACCESS_COLOR = "#CC3A52";

export const NETWORK_PROVIDER_COLOR = "#056edf";
export const TERMINATED_PROVIDER_COLOR = "#32323C";
export const PROSPECT_PROVIDER_COLOR = "#FF5500";
export const MARKET_PROVIDER_COLOR = "#8B00FF";
export const TARGET_PROVIDER_COLOR = "#FF00FF";
export const EXCLUDED_PROVIDER_COLOR = "#ADE8F4";

export const NETWORK_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR = "#DCECFF";
export const NETWORK_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR = "#056EDF";

export const IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_SUCCESS = "#EBF5F2";
export const IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_SUCCESS = "#008559";

export const IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_WARNING = "#FFFCF1";
export const IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_WARNING = "#FFD654";

export const IMPACT_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR_DANGER = "#FBEFF1";
export const IMPACT_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR_DANGER = "#CC3A52";

export const ZIP_CODE_BORDER_COLOR = "#404142";

export const PROVIDER_ACCORDION_BUTTON_COLOR = "#1c78d6";

// Use a RGB color for this shadow to preserve the opacity
export const PROVIDER_ICON_SHADOW_COLOR = "rgba(50, 50, 60, 0.5)";

export const DEFAULT_COLOR = "rgba(0, 0, 0, 0)";

export const MEMBERS_IMAGE_ID = "members-image";

/*
  "Providers" is the name of the SVG icon defined in Mapbox Studio. All themes used for this map
  must include the "Providers" SVG icon.
*/
export const PROVIDER_ICON_IMAGE_ID = "Providers";

export const COUNTY_BORDER_SOURCE_ID = "county-borders-source";
export const COUNTY_BORDER_LAYER_ID = "county-borders-layer";

export const CONTEXT_COUNTY_COLOR = "#828384";
export const CONTEXT_COUNTY_BORDER_SOURCE_ID = "context-county-borders-source";
export const CONTEXT_COUNTY_BORDER_LAYER_ID = "context-county-borders-layer";
export const STATE_BORDER_COLOR = "#404142";
export const STATE_BORDER_SOURCE_ID = "state-borders-source";
export const STATE_BORDER_LAYER_ID = "state-borders-layer";
export const COUNTY_LABEL_SOURCE_ID = "county-labels-source";
export const COUNTY_LABEL_LAYER_ID = "county-labels-layer";
export const COUNTY_LABEL_COLOR = "#0F0F0F";
export const COUNTY_LABEL_TEXT_SIZE = 11;
// Translucent so provider and member points stay visible under the labels.
export const COUNTY_LABEL_TEXT_OPACITY = 0.9;
export const COUNTY_LABEL_HALO_COLOR = "rgba(255, 255, 255, 0.6)";

export const MEMBER_SOURCE_ID = "members-source"
export const MEMBER_LAYER_ID = "members-layer";

export const SELECTED_PROVIDER_SOURCE_ID = "selected-provider-source";
export const PROVIDER_HIGHLIGHTED_LAYERD_ID = "providers-layer-highlighted";

export const PROVIDERS_SOURCE_ID = "providers-source";
export const PROVIDERS_LAYER_ID = "providers-layer";

export const ZIPCODE_SOURCE_ID = "zipcode-source"
export const ZIPCODE_LAYER_ID = "zipcode-layer";
export const ZIPCODE_LABEL_LAYER_ID = "zipcode-label-layer";
export const ZIPCODE_MIN_ZOOM_LEVEL = 8;

export const PROVIDER_ICON_UNSELECTED_MIN_SIZE = 0.25;
export const PROVIDER_ICON_UNSELECTED_MAX_SIZE = 0.3;
export const PROVIDER_ICON_SELECTED_SIZE = 0.5;

export const VIEW_PADDING = 50;
// Provider accordion width + viewPadding.
export const ACCORDION_OPEN_PADDING = 380 + VIEW_PADDING;

export const ZERO_PERCENT_FILTER = 0;
export const HUNDRED_PERCENT_FILTER = 100;

export const MAX_TIMESLICES = 25;
export const MAX_TIMESLICES_WITH_UNPUBLISHED = 26;